export default __webpack_public_path__ + "compact-c7c97fc91d876ca01e9c18e566b2aa32.svg";